<template>
  <b-card
    class="text-center"
    body-class="pb-50"
  >
    <b-avatar
      size="48"
      :style="{ backgroundColor: color+'1F', color: color}"
    >
      <feather-icon
        size="24"
        :icon="icon"
      />
    </b-avatar>
    <h6 class="pt-1">
      {{ title }}
    </h6>
    <h2 class="font-weight-bolder mb-1">
      {{ total }}
    </h2>
  </b-card>
</template>

<script>
import { BAvatar, BCard } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    total: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>
